import { HttpClient, HttpParams, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
/**
* Clase base para los Servicios de datos.
*/
export abstract class CallService {

  /**
   *
   * @param http
   */
  constructor(protected http: HttpClient) {
    ////console.log('CallService -->> ', new Date())
  }

  /**
  *
  * @param url
  * @param parametros
  */
  public getSinToken<T>(url: string, parametros?: HttpParams) {

    //console.log('url -->> ', url);
    //console.log('parametros -->> ', parametros);

    const httpHeaders = new HttpHeaders()
      .set('Accept', 'application/json')

    return this.http.get<T>(url, {
      headers: httpHeaders,
      params: parametros,
      observe: 'response',  // Para acceder a la respuesta completa
      responseType: 'json'
    }).pipe(
      // tap(response => {
      //   console.log('Status (Éxito):', response.status); // Solo para 200-299
      //   console.log('Headers:', response.headers);
      //   console.log('Body:', response.body);
      // }),
      map(response => response.body as T),  // Extrae el body
      catchError((error: HttpErrorResponse) => {
        console.error('Error status:', error.status); // Captura 401, 404, 500, etc.
        console.error('Error message:', error.message);

        if (error.status === 401) {
          console.log('🔴 Error 401: Token inválido o expirado');
          // Opcional: Redirigir a login o refrescar el token
        }

        return throwError(() => error); // Reenvía el error para manejo en el componente
      })
    );

  }

  public get<T>(url: string, token: string, parametros?: HttpParams) {

    //console.log('url -->> ', url);
    //console.log('parametros -->> ', parametros);

    // const httpHeaders = new HttpHeaders()
    //   .set('Accept', 'application/json')
    //   .set('Authorization', `Bearer ${token}`);

    // return this.http.get<T>(url, { headers: httpHeaders, params: parametros, responseType: 'json' })

    const httpHeaders = new HttpHeaders()
      .set('Accept', 'application/json')
      .set('Authorization', `Bearer ${token}`);

    return this.http.get<T>(url, {
      headers: httpHeaders,
      params: parametros,
      observe: 'response',  // Para acceder a la respuesta completa
      responseType: 'json'
    }).pipe(
      // tap(response => {
      //   console.log('Status (Éxito):', response.status); // Solo para 200-299
      //   console.log('Headers:', response.headers);
      // }),
      map(response => response.body as T),  // Extrae el body
      catchError((error: HttpErrorResponse) => {
        console.error('Error status:', error.status); // Captura 401, 404, 500, etc.
        console.error('Error message:', error.message);

        if (error.status === 401) {
          console.log('🔴 Error 401: Token inválido o expirado');
          // Opcional: Redirigir a login o refrescar el token
        }

        return throwError(() => error); // Reenvía el error para manejo en el componente
      })
    );

  }

  /**
   *
   * @param url
   * @param parametros
   */
  public post<T>(url: string, entity: any, token: string) {

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `Bearer ${token}`
    });

    return this.http.post<T>(url, JSON.stringify(entity), {
      headers: headers,
      observe: 'response'
    }).pipe(
      // tap(response => {
      //   console.log('Status:', response.status); // Solo se ejecuta en respuestas exitosas (200-299)
      //   console.log('OK:', response.ok); // true (200-299)
      // }),
      map(response => response.body as T), // Extrae el body
      catchError((error: HttpErrorResponse) => {
        console.error('Error status:', error.status); // Aquí sí se captura el 401
        console.error('Error message:', error.message);

        // Puedes manejar el error específicamente para el 401
        if (error.status === 401) {
          console.log('🔴 Error 401: No autorizado (token inválido o expirado)');
          // Aquí podrías redirigir a login o refrescar el token
        }

        // Re-lanzamos el error para que el componente también lo maneje
        return throwError(() => error);
      })
    );
  }

  // En call.service.ts
  public postFile<T>(url: string, formData: FormData, token: string) {
    //console.log('🔵 POST File - URL:', url);
    //console.log('🔵 FormData contenido:');

    // Log para debug del FormData
    formData.forEach((value, key) => {
      console.log(`   ${key}:`, value);
    });

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
      // NO incluir 'Content-Type': multipart/form-data - se genera automáticamente con boundary
    });

    return this.http.post<T>(url, formData, {
      headers: headers,
      observe: 'response'
    }).pipe(
      // tap(response => {
      //   console.log('✅ POST File - Status:', response.status);
      //   console.log('✅ POST File - OK:', response.ok);
      // }),
      map(response => response.body as T),
      catchError((error: HttpErrorResponse) => {
        console.error('❌ POST File - Error status:', error.status);
        console.error('❌ POST File - Error message:', error.message);

        if (error.status === 401) {
          console.log('🔴 Error 401: Token inválido o expirado');
        }

        return throwError(() => error);
      })
    );
  }

  /**
   *
   * @param parametros
   * @param nombreParametro
   * @param valorParametro
   */
  protected addParameter(parametros: HttpParams, nombreParametro: string, valorParametro: any) {

    if (nombreParametro != undefined && valorParametro != undefined) {
      parametros.append(nombreParametro, valorParametro);
    }

  }

}
